<div
  data-id="bd-internal-server-error"
  *transloco="let t; scope: 'uiComponents'; prefix: 'uiComponents'"
>
  <div
    class="flex absolute inset-0 h-screen w-screen justify-center items-center"
  >
    <bd-call-to-action
      [title]="{ textKey: 'internalServerError.title', tScope: 'uiComponents' }"
      [subtitle]="{
        textKey: 'internalServerError.subtitle',
        tScope: 'uiComponents',
      }"
      [actionButton]="actionButton"
      ><span class="bd-display-large">{{
        t('internalServerError.code')
      }}</span></bd-call-to-action
    >
  </div>
</div>
